"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _xlsx = _interopRequireDefault(require("xlsx"));
var _sortablejs = _interopRequireDefault(require("sortablejs"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'userList',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  data: function data() {
    var _this = this;
    return {
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 86400;
          }
        }
      },
      issueArr: {
        1: '订单问题',
        2: '系统bug',
        3: '其他问题',
        4: '设备问题'
      },
      statusObj: {
        0: '未处理',
        1: '处理中',
        2: '已处理'
      },
      form: {},
      tableMaxH: '250',
      numInfo: {},
      list: [],
      listLoading: true,
      listQuery: {
        deal_status: this.$route.query.deal_status || '3',
        start: 1,
        total: 10,
        page_num: 1,
        limit: 20
      },
      issue: {},
      replyDialog: false,
      replyObj: {},
      dealDialog: false,
      deal_status: 1,
      remark: '',
      outStatus: false,
      excel: false,
      percentage: 0,
      wbout: {},
      wi: 0
    };
  },
  computed: {
    xlsxName: function xlsxName() {
      var xlsxName = '反馈记录';
      return xlsxName;
    },
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    },
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    }
  },
  mounted: function mounted(options) {
    this.getNum();
    this.getList();
  },
  methods: {
    /**
     * 数量
     */
    getNum: function getNum() {
      var _this2 = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        user_type: this.user_type
      });
      this.$get('agentapi/feedback/list_num', listQuery).then(function (res) {
        _this2.numInfo = res;
      });
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getNum();
      this.getList();
    },
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.listQuery.deal_status = tab.name;
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this3 = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/feedback/index';
      this.$get(url, listQuery).then(function (res) {
        if (_this3.outStatus) {
          _this3.list = res.list;
          if (listQuery.limit > res.list.length) {
            _this3.listLoading = false;
            _this3.percentage = 100;
          } else {
            _this3.listQuery.start++;
            _this3.percentage = _this3.percentage < 95 ? _this3.percentage + 5 : 95;
          }
          _this3.$nextTick(function () {
            _this3.outTabdd('list_table', _this3.xlsxName);
          });
        } else {
          _this3.listLoading = false;
          _this3.list = res.list;
          _this3.listQuery.page_num = res.page_num;
        }
        if (listQuery.start == 0) _this3.tableMaxH = window.innerHeight - _this3.$refs.list_table.$el.offsetTop - 82;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    /**
     * 回复
     */
    reply: function reply() {
      var _this4 = this;
      // 【操作埋点】2026-05-25 pc_feedback_reply_1 回复用户反馈
      this.$post('commonapi/feedback/reply', {
        id: this.issue.id,
        type: 0,
        content: this.replyObj.content
      }).then(function (res) {
        _this4.$feedbackReport.reportFeedbackReply(_this4.issue.id, _this4.issue.content, _this4.replyObj.content);
        _this4.replyDialog = false;
        _this4.issue.reply_list.push({
          add_date: Date.parse(new Date()) / 1000,
          content: _this4.replyObj.content
        });
        _this4.$message({
          message: '回复成功',
          type: 'success'
        });
      });
    },
    /**
     * 处理
     */
    deal: function deal() {
      var _this5 = this;
      // 【操作埋点】2026-05-25 pc_feedback_deal_1 处理用户反馈状态
      this.$post('agentapi/feedback/dealed_switch', {
        id: this.issue.id,
        deal_status: this.deal_status,
        remark: this.remark
      }).then(function (res) {
        _this5.$feedbackReport.reportFeedbackDeal(_this5.issue.id, _this5.issue.content, _this5.deal_status, _this5.remark);
        _this5.dealDialog = false;
        _this5.issue.deal_status = _this5.deal_status;
        _this5.issue.remark = _this5.remark;
        _this5.$message({
          message: '设置成功',
          type: 'success'
        });
      });
    },
    /**
     * 导出
     */
    outTable: function outTable() {
      this.outStatus = true;
      this.listLoading = true;
      this.listQuery.limit = 100;
      this.list = [];
      this.excel = true;
      this.getList();
    },
    /**
     * 导出表格
     */
    outTabdd: function outTabdd(tabId) {
      var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data';
      console.log(tabId);
      var fix = document.querySelector('.el-table__fixed-right');
      var xlsxParam = {
        raw: true
      };
      var wb;
      if (fix) {
        this.wbout[this.wi] = _xlsx.default.utils.table_to_book(document.querySelector("#".concat(tabId)).removeChild(fix), xlsxParam);
        document.querySelector("#".concat(tabId)).appendChild(fix);
      } else {
        this.wbout[this.wi] = _xlsx.default.utils.table_to_book(document.querySelector("#".concat(tabId)), xlsxParam);
      }
      this.wi++;
      console.log(this.listLoading);
      if (this.listLoading) {
        this.getList();
        return;
      }
      var wboutes = this.wbout[0];
      var no = '';
      for (var i in this.wbout) {
        delete this.wbout[i].Sheets.Sheet1['!merges'];
        if (i > 0) {
          var sheet1 = this.wbout[i].Sheets.Sheet1;
          for (var s in sheet1) {
            var k = s.substring(0, 1);
            var n = s.substring(1);
            if (n != 1 && n != 'ref') {
              var _k = s.substring(0, 1);
              n = s.substring(1);
              no = parseInt(i) * 100 + parseInt(n);
              sheet1[_k + no] = sheet1[s];
            }
            delete sheet1[s];
          }
          wboutes.Sheets.Sheet1 = Object.assign(wboutes.Sheets.Sheet1, sheet1);
        }
      }
      if (this.wbout[1]) wboutes.Sheets.Sheet1['!ref'] = "A1:Q".concat(no);
      var wbout = _xlsx.default.write(wboutes, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });
      this.percentage = 100;
      if (!this.listLoading) {
        try {
          _fileSaver.default.saveAs(new Blob([wbout], {
            type: 'application/octet-stream'
          }), "".concat(fileName, ".xlsx"));
          this.excel = false;
          this.$message({
            message: '导出成功',
            type: 'success'
          });
          setTimeout(function () {
            location.reload();
          }, 1000);
        } catch (e) {
          if (typeof console !== 'undefined') console.log(e, this.wbout);
        }
        return this.wbout;
      }
    }
  }
};